import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useField } from '@unform/core';
import {
  InputLabel,
  Checkbox,
  Select as SelectMaterialUI,
  MenuItem,
  FormControl,
  FormHelperText,
  SelectChangeEvent,
} from '@material-ui/core';

interface SelectProps {
  name: string;
  valor: string[];
  label: string[];
  valorDefault: string;
  title: string;
}
const Select: React.FC<SelectProps> = ({
  name,
  label,
  valor,
  valorDefault,
  title,
  ...rest
}) => {
  const inputRef = useRef(null);

  const [select, setSelect] = React.useState(valorDefault);

  const handleChange = (event: SelectChangeEvent<string>) => {
    console.log(name, label, valor, valorDefault, title);
    setSelect(event.target.value as string);
  };
  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName, select]);

  return (
    <div>
      <InputLabel
        id="select-label"
        style={{ marginBottom: '4px', marginLeft: '2px' }}
      >
        {title}
      </InputLabel>
      <FormControl>
        <SelectMaterialUI
          value={select}
          onChange={handleChange}
          defaultValue=""
          style={{ minWidth: '250px' }}
          inputRef={inputRef}
          inputProps={{ 'aria-label': 'Without label' }}
        >
          <MenuItem value="">
            <em>-</em>
          </MenuItem>
          {label.map((lab, idx) => (
            <MenuItem value={valor[idx]} key={Object.keys(valor[idx])[0]}>
              <em>{lab}</em>
            </MenuItem>
          ))}
        </SelectMaterialUI>
      </FormControl>
    </div>
  );
};

export default Select;
